import * as React from 'react';
import AspectRatio from '../../../ui/AspectRatio';

export default function MinglVideo() {
  return (
    <section className="tc pb5 pb0-l ph4-l w-100" style={{ flexBasis: '60%' }}>
      <div className="center mb3">
        <AspectRatio ratio="16x9">
          <iframe
            className="bn w-100 h-100"
            src="https://player.vimeo.com/video/294596149?byline=0&portrait=0"
            allowFullScreen={true}
          />
        </AspectRatio>
      </div>
    </section>
  );
}
